module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }, [_c('div', {
    staticClass: "image_wrap color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_c('div', {
    staticClass: "illustype_image_text_net"
  }, [_c('img', {
    attrs: {
      "alt": "toc.jpg",
      "src": "images/toc.jpg"
    }
  })])])]), _c('p', {
    staticClass: "running_first"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/005part01"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("8 Intro")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/007chapter02"
    }
  }, [_vm._v("12 Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/008chapter03"
    }
  }, [_vm._v("14 Grilling Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('a', {
    attrs: {
      "href": "#/html/009part02"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("16 Appetizers")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/011chapter05"
    }
  }, [_vm._v("18 Scallops & Prosciutto on Rosemary Skewers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/012chapter06"
    }
  }, [_vm._v("19 Spicy Steak Sticks")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/013chapter07"
    }
  }, [_vm._v("20 Spicy & Messy Chicken Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/015chapter09"
    }
  }, [_vm._v("22 Barbecued Wings Charlotte Style")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/016chapter10"
    }
  }, [_vm._v("24 Korean Short Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/017chapter11"
    }
  }, [_vm._v("25 Prosciutto-Wrapped Grilled Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/018chapter12"
    }
  }, [_vm._v("26 Grilled Apricot Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "href": "#/html/019chapter13"
    }
  }, [_vm._v("27 Queso Fundido")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/020chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 Grilled Skillet Nachos")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/021chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Grilled Red Pepper Hummus Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/022chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Spanish Potato Tortilla")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/023chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Grilled Poblano Pepper, Cheddar Cheese & Black Bean Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/024chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33 Grilled Crab Cakes with Chipotle Mayonnaise")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/025part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("34 Beef")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/027chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38 Rib-Eyes with Grilled Sweet Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/028chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39 Skirt Steak Fajitas")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/029chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40 Teriyaki Flank Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/030chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41 Grilled Beef Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/031chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42 Beef Satay")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/032chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43 Coal-Roasted Prime Rib")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/033chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44 Thai-Style Rib-Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/034chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46 Grilled Porterhouse")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/035chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48 Moroccan-Style Hanger Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/036chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49 Grilled Steak Sandwich")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p6"
    }
  }), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('a', {
    attrs: {
      "id": "p6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/037chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50 Strip Steaks with Chimichurri Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/038chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52 Veal Chops with Morels")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/039part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("54 Pork")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/041chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56 Honey-Glazed Spareribs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/042chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58 Beer-Besotted Slow-Cooked Pork Loin")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/043chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60 Spicy Pork & Pineapple Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/044chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62 Pork Chops with Cherry Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/045chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64 Cider & Honey–Glazed Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/046chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65 Pork Chops Asado")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/047chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66 Jerk Pork Tenderloin")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/048chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68 Grilled Pork Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/049chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70 Rolled Pork Shoulder")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/050part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("72 Lamb")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/052chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74 Lamb Picadillo")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/053chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76 Grilled Lamb Shanks")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/054chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77 Father’s Day Lamb Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/055chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80 Lamb & Merguez Kabobs with Mint Yogurt Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/056chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82 Grilled Chipotle Leg of Lamb")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/057part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("84 Poultry")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/059chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87 Barbecued Game Hens “Under the Brick”")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/060chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88 Mexican Wedding Chicken Mole")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/061chapter51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90 Chicken Fingers with Spicy Peanut Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/062chapter52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92 Grilled Quail")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/063chapter53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93 Chicken Thighs Cubano")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/064chapter54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94 Chicken Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/065chapter55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95 Sesame Chicken Drumsticks")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/066chapter56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96 Greek Salad with Grilled Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/067chapter57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98 Grilled Chicken Parm")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/068chapter58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99 Comino-Honey-Glazed Boneless Turkey Breast")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/069part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("100 Fish & Seafood")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/071chapter60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103 Grilled Halibut Reggio Emilia style")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/072chapter61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104 Salade Niçoise with Grilled Tuna")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/073chapter62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105 Grilled Cajun Catfish Fillets")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/074chapter63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106 Trout Fillets in Foil")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/075chapter64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107 Grilled Pecan-Crusted Trout Fillets")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/076chapter65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108 Grilled Swordfish Kabobs with Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/077chapter66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110 Grouper with Zesty Apricot Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/078chapter67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111 Miso-Ginger Marinated Grilled Salmon")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/079chapter68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112 Salmon with Mango Salsa")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/080chapter69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129 Striped Bass Fillets with Tomato & Corn Relish")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/081chapter70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130 Grilled Snapper Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/082chapter71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131 Shrimp & Smoked Sausage Kabobs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/083chapter72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132 Mediterranean Jumbo Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/084chapter73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133 Grilled Lobster Tails")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/085part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("134 Burgers, Dogs & Brats")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/088chapter76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137 Foolproof Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/089chapter77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138 Lamb Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/090chapter78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140 Cajun Turkey Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/091chapter79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141 Tuna Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/092chapter80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142 Dad Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/093chapter81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143 Mexican Chicken Burgers")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/095chapter83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145 Chicago-Style Hot Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/096chapter84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148 Classic Grilled Brats")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/097chapter85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149 Brats with Cherries & Bacon")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "p7"
    }
  }, [_c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  })]), _c('p', {
    staticClass: "running_first"
  }, [_c('a', {
    attrs: {
      "id": "p7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/html/098part09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("150 Sammies & Pizza")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/100chapter87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152 Classic Panini")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/101chapter88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154 Panino Monstro")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/102chapter89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155 Leftover Chicken & Cheddar Quesadillas")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/103chapter90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156 Pulled Pork Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/104chapter91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158 Grilled Veggie Muffuletta")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/105chapter92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160 Grilled Pizza with Pepperoni & Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/106chapter93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162 Pizza Dough")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/107chapter94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163 Grilled Pizza with Shrimp & Feta")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/108part10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("166 Smoking on Your Grill")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/110chapter96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170 Kansas City–Style Beef Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/111chapter97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172 Smoked Brisket")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/112chapter98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174 Smoked Sausage, Pepper & Grilled Onion Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/113chapter99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175 Smoked Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/114chapter100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176 Bacon-Wrapped Smoked Loin of Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/115chapter101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177 Smoked Baby-Back Ribs")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/116chapter102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178 Smoked Wings Buffalo-Style")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/117chapter103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180 Dad’s All-Purpose Barbecue Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/118chapter104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181 Smoked Shrimp with Jalapeño Mayo")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/119part11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("182 10 Super-Fast, Foolproof Grilling Recipes")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/121chapter106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184 Chicken Breasts with Sun-Dried Tomato Pesto")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/122chapter107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184 Boneless Chicken Thighs Drenched with BBQ Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/123chapter108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185 Herbed Lemon Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/124chapter109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185 Apricot-Glazed Ham Steak")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/125chapter110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186 Citrus Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/126chapter111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187 Grilled Lemon Rosemary Salmon in Foil")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/127chapter112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188 Savory Roast Beef Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/128chapter113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189 Grilled Veal Chops with Savory Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/129chapter114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190 Grilled Scallops with Sweet Chili Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/130chapter115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191 Steak Tacos")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/131part12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("192 Sides & Desserts")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/133chapter117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194 White Bean, Smoked Sausage & Artichoke Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/134chapter118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195 Grilled Polenta")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/135chapter119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196 Grilled Sweet Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/136chapter120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196 Classic Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/137chapter121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197 Potato Packets")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/138chapter122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198 Roasted Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/139chapter123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199 Mac & Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/140chapter124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200 Fragrant Rice")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/141chapter125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201 Baked Brown Rice Pilaf")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/142chapter126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202 Backyard Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/143chapter127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203 Roasted Corn with Chipotle Butter")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/144chapter128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204 Roasted Corn & Sweet Onion Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/145chapter129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205 Guacamole")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/146chapter130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206 Collard Greens")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/147chapter131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207 Creamed Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/148chapter132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208 Sweet & Spicy Corn Muffins")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/149chapter133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209 Skillet Focaccia")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/150chapter134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210 Double Chocolate Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/151chapter135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211 Bananas Foster")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/152chapter136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212 Moose Tracks Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "running_first color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }, [_c('span', {
    attrs: {
      "href": "#/html/153chapter137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213 Pear-Apple-Cranberry Crisp")])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-3C1C00 font-AtmaSerif-MediumRoman-5_1-12"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/154index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-GoudyHeavyfaceBT-Regular-3_1-11_75 color-FF5100"
  }, [_vm._v("214 Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_txt_indent color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }), _vm._v(" "), _c('p', {
    staticClass: "running_first"
  }, [_c('span', {
    attrs: {
      "href": "#/html/155backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "color-FF5100 font-GoudyHeavyfaceBT-Regular-3_1-11_75"
  }, [_vm._v("224 Table of Equivalents")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dd7f2dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/004contents.vue
// module id = 66
// module chunks = 0